import { render, staticRenderFns } from "./OrderDispatch.vue?vue&type=template&id=1d7e8daa&"
import script from "./OrderDispatch.vue?vue&type=script&lang=js&"
export * from "./OrderDispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports